import type {Timestamp} from '../../../utils/datetime';

type ConferenceType = 'audio' | 'video';

type Config = {
  isVideoEnabled?: boolean;
};

export class ConferenceStats {
  private durationWithoutVideo = 0;
  private startTime: Timestamp;
  // means time when a user disabled video
  private videoDisabledTime: null | Timestamp = null;

  constructor(config?: Config) {
    // we consider that video is enabled at start
    if (config && !config.isVideoEnabled) {
      this.videoDisabledTime = Date.now();
    }
  }

  getConferenceDuration() {
    const now = Date.now();

    return now - (this.startTime || now);
  }

  getConferenceType(): ConferenceType {
    const conferenceDuration = this.getConferenceDuration();

    const halfOfConferenceDuration = conferenceDuration / 2;

    let durationWithoutVideo = this.durationWithoutVideo;

    if (this.videoDisabledTime) {
      durationWithoutVideo =
        Date.now() - this.videoDisabledTime + durationWithoutVideo;
    } else {
      durationWithoutVideo = 0;
    }

    return conferenceDuration - durationWithoutVideo > halfOfConferenceDuration
      ? 'video'
      : 'audio';
  }

  setIsVideoEnabled(isVideoEnabled: boolean) {
    const now = Date.now();

    if (isVideoEnabled) {
      const durationWithoutVideo =
        now - (this.videoDisabledTime || now) + this.durationWithoutVideo;

      this.durationWithoutVideo = durationWithoutVideo;

      this.videoDisabledTime = null;
    } else {
      this.videoDisabledTime = now;
    }
  }

  setStartTime(time: Timestamp) {
    this.startTime = time;
  }
}
